import { useEffect } from 'react';
import Filters from './FilterAndGroupBy';
// import Filters from '../../canopy-ui-components/components/Filters/SimpleFilters';

export const filterOptions = ['device', 'partner_name', 'role_name', 'none'];

const DEFAULT_FILTER_GROUP = 'role_name';
const DEFAULT_FILTER = ['manager'];

function SimpleFilters({
    layoutState,
    setLayoutState,
    dataKey,
    filterApi,
    globalProps,
    selectedGroupBy,
    selectedGroupByFilters,
    setSelectedGroupBy,
    setSelectedGroupByFilters,
    setGroupBy,
    setGroupByFilters,
    groupBy,
    groupByFilters,
    setUserId,
    userId,
}: any) {
    const onApplyFilter = (
        filters: string[][],
        groupBy: string[] = ['select-one'],
        clientSideFilterValue: any
    ) => {
        setSelectedGroupBy(groupBy);
        setSelectedGroupByFilters([...filters]);
        setLayoutState((layoutState: any) => {
            return {
                ...layoutState,
                clientFilters: {
                    app_id: clientSideFilterValue,
                },
                group_by:
                    groupBy[0] === 'select-one' || groupBy[0] === 'none'
                        ? ''
                        : groupBy[0],
                [groupBy[0]]:
                    groupByFilters?.[groupBy[0]]?.length !== filters[0]?.length
                        ? escape(JSON.stringify(filters[0]))
                        : '',
            };
        });
    };

    useEffect(() => {
        setGroupBy([...filterOptions]);
        setUserId(layoutState?.user_id);
        setLayoutState((layoutState: any) => {
            return {
                ...layoutState,
                clientFilters: {
                    app_id: layoutState?.clientFilters?.app_id || ['manager'],
                },
            };
        });
    }, [layoutState.user_id]);

    useEffect(() => {
        setSelectedGroupBy([layoutState.group_by || 'none']);
    }, [layoutState.group_by]);

    return (
        <Filters
            globalProps={globalProps}
            groupByFilters={groupByFilters}
            selectedGroupByFilters={selectedGroupByFilters}
            groupBy={groupBy}
            selectedGroupBy={selectedGroupBy}
            allowMultipleFilters={false}
            isClientSideFilter={true}
            defaultGroupBy={DEFAULT_FILTER_GROUP}
            defaultFilter={DEFAULT_FILTER}
            selectAllFiltersOnGroupChange={true}
            showGroupByFilters={false}
            headerText="ui.mm.group-by"
            layoutState={layoutState}
            setLayoutState={setLayoutState}
            onApply={onApplyFilter}></Filters>
    );
}
export default SimpleFilters;
